import CueLiveContentContext from '@contexts/cueLiveContent'
import { useContext } from 'react'

const useIsInCueLiveContent = (): boolean => !!useContext(CueLiveContentContext)

export default useIsInCueLiveContent
